import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

const FrenchFlag = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" className="rounded-full">
    <clipPath id="fr-circle">
      <circle cx="12" cy="12" r="12" />
    </clipPath>
    <g clipPath="url(#fr-circle)">
      <rect x="0" y="0" width="8" height="24" fill="#002395" />
      <rect x="8" y="0" width="8" height="24" fill="#FFFFFF" />
      <rect x="16" y="0" width="8" height="24" fill="#ED2939" />
    </g>
  </svg>
);

const BritishFlag = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" className="rounded-full">
    <clipPath id="gb-circle">
      <circle cx="12" cy="12" r="12" />
    </clipPath>
    <g clipPath="url(#gb-circle)">
      <rect width="24" height="24" fill="#012169" />
      <path d="M0,0 L24,24 M24,0 L0,24" stroke="#fff" strokeWidth="4" />
      <path d="M0,0 L24,24 M24,0 L0,24" stroke="#C8102E" strokeWidth="2.5" />
      <path d="M12,0 V24 M0,12 H24" stroke="#fff" strokeWidth="6" />
      <path d="M12,0 V24 M0,12 H24" stroke="#C8102E" strokeWidth="3.5" />
    </g>
  </svg>
);

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith('en') ? 'en' : 'fr';

  const toggleLanguage = () => {
    const newLang = currentLang === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleLanguage}
      className="h-8 w-8 rounded-full hover:bg-slate-100 p-0 overflow-hidden"
      aria-label={currentLang === 'fr' ? 'Switch to English' : 'Passer en français'}
    >
      {currentLang === 'fr' ? <FrenchFlag /> : <BritishFlag />}
    </Button>
  );
}
